import { render, staticRenderFns } from "./contact-request-assign-dialog.vue?vue&type=template&id=2254d2e6&scoped=true&"
import script from "./contact-request-assign-dialog.vue?vue&type=script&lang=js&"
export * from "./contact-request-assign-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2254d2e6",
  null
  
)

export default component.exports